// エクスポートした関数読み込み
// 2021_12_22_00:00段階 121kb コンパイル後

import { swiper } from "./main/swiper.js"; //62kb bundle 133kb
import { matchHeight } from "./main/matchHeight.js"; //1kb
// import { oncontextmenu } from "./main/oncontextmenu.js"; //0kb 右クリック禁止
import { budoux } from "./main/budoux.js"; //12kb
import { Alpinejs } from "./main/alpinejs.js"; //46.6kb
import { scroll } from "./main/scroll.js"; //0kb

import { common } from "./main/common.js"; //0kb

//import { sp } from "./main/sp.js"; //0kb
import { webfont } from "./main/webfont.js";
import { fontawesome } from "./main/fontawesome.js"; //0kb

// 関数を実行
swiper();
matchHeight();
// oncontextmenu();
budoux();
Alpinejs();
scroll();
// sp();
webfont();

common();
fontawesome();
